export const paths = {
  home: '/',
  mock: '/mock',
} as const;
